import React from "react";

import useAuth from "../../routes/login/AuthContext";
import { Grid } from "../../UI/Grid";
import { DeleteButton } from "./DeleteButton";
import { EditButton } from "./EditButton";

interface IProps {
  isDeleteLoading?: boolean;
  isEditLoading?: boolean;
  handleEdit: VoidFunction;
  handleDelete: VoidFunction;
  editDisabled?: boolean;
  children?: React.ReactNode;
}

export const TableRowOptions: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();

    let editDisabled = props.editDisabled == undefined ? false : props.editDisabled;
    return (
    <Grid container spacing={1} wrap="nowrap" justifyContent="flex-end">
      <Grid item>{props.children}</Grid>
      <Grid item>
        <DeleteButton isDisabled={isSuperAdminRead() || editDisabled} isLoading={props.isDeleteLoading} handleDelete={props.handleDelete} />
      </Grid>
      <Grid item>
        <EditButton isDisabled={isSuperAdminRead() || editDisabled} isLoading={props.isEditLoading} handleEdit={props.handleEdit} />
      </Grid>
    </Grid>
  );

};